import * as React from "react";

const fields = (t) => {return {
    config: {columns: 3},
    fields: [
        {
            name: "name",
            label: t ? t("common.name") : "Nazwa",
            mandatory: true,
            column: 1,
        },
        {
            name: "internalNumber",
            label: t ? t("common.internal_number") : "Numer wewnętrzny",
            column: 2,
        },
        {
            name: "packingSystem",
            label: t ? t("common.packing_system") : "System pakowania",
            type: "enum",
            enumType: "enums/packingSystem",
            column: 2,
        },
        {
            name: "room",
            label: t ? t("common.room") : "Pomieszczenie",
            column: 1,
        },
        {
            name: "commonImages",
            label: t ? t("common.complete_line_photo") : "Zdjęcie kompletnej linii",
            column: 3,
            type: "file",
        },
    ]


}};

export default fields;